import { GetAppVersionResponse } from '../models/AppVersionResponse.interface'

export const getAppVersion = async (): Promise<GetAppVersionResponse> => {
    const res = await fetch(`${process.env.REACT_APP_CRN_APP_BASE_URL}/system/deploymentinfo/?include=application`)
    if (!res.ok) {
        throw new Error(`Failed to fetch CPMS version: ${res.status}`)
    }
    return res.json() as Promise<GetAppVersionResponse>
}

export default { getAppVersion }
